<template>
    <div class="unit-info-prometheus show-info"
         :class="[!isSectionInfoOpen && 'show-info--close']"
    >
        <button class="button button-close"
                :class="[!isSectionInfoOpen && 'button-close-info']"
                @click="toggleList"
        >
            <SvgIcon name="buble-arrow" class="icon" v-if="!isSectionInfoOpen"/>
        </button>

        <component :is="componentBlockInfo" :unitId="unitId" v-show="isSectionInfoOpen"></component>

    </div>

    <router-view :class="$attrs.class"></router-view>

    <Teleport to="#sectionInfoByPage" :key="componentBlockInfo">
        <router-view name="info"></router-view>
    </Teleport>

    <Teleport to="#sectionInfoByRoute">
        <router-view :class="$attrs.class" name="sectionInfoByRoute" v-on:close-dialog="onCloseSectionInfoByRoute"></router-view>
    </Teleport>
</template>

<script>
import UnitInfo_content_reefer from '@/components/units/pageInfo/info-block/UnitInfo_content_reefer.vue';
import UnitInfo_content_base from '@/components/units/pageInfo/info-block/UnitInfo_content_base.vue';
import unitMixin from "@/mixins/unitMixin";
import {mapGetters} from "vuex";

export default {
    name: "UnitInfo",
    inject: ['fnAddPageClass', 'fnRemovePageClass'],
    mixins: [unitMixin],
    props: {
        unitId: Number,
    },
    data() {
        return {
            isSectionInfoOpen: true,
        }
    },
    components: {
        UnitInfo_content_base,
        UnitInfo_content_reefer,
    },
    computed: {
        ...mapGetters([
            "getWindowWidth",
        ]),
        componentBlockInfo() {
            return this.routeMeta.componentBlockInfo || 'UnitInfo_content_base';
        },
        watchSectionInfoOpen() {
            return [this.mainRouteName, this.unitId, this.getWindowWidth].join(';')
        },
        hideInfoUnit() {
            return !!this.routeMeta?.hideInfoUnit
        },
    },
    watch: {
        watchSectionInfoOpen: {
            handler: function () {
                this.updateSectionInfoOpen()
            },
        },
    },
    methods: {
        onCloseSectionInfoByRoute(){
            this.setRoute.returnToParent(this.$route, this.$router)
        },
        toggleList() {
            this.isSectionInfoOpen = !this.isSectionInfoOpen
            if(this.isSectionInfoOpen) {
                this.fnAddPageClass('open-info')
            } else {
                this.fnRemovePageClass('open-info')
            }
            // this.setRoute.unitId(this.$route, this.$router, this.unitId)
        },
        updateSectionInfoOpen() {
            this.isSectionInfoOpen = (this.getWindowWidth <= 1700) ? false : !this.hideInfoUnit
            if(!this.isSectionInfoOpen) {
                this.fnRemovePageClass('open-info')
            }

        }
    },
    created() {
        this.updateSectionInfoOpen();
    },
    mounted() {
    }
}
</script>

<style lang="scss" scoped>
</style>
<style>
</style>